// extracted by mini-css-extract-plugin
export const twoColumnSection = "twoColumnSection-module--twoColumnSection--2RmU1";
export const sectionContainer = "twoColumnSection-module--sectionContainer--3psCJ";
export const desktopImage = "twoColumnSection-module--desktopImage--1dI6O";
export const textWrap = "twoColumnSection-module--textWrap--3aysw";
export const content = "twoColumnSection-module--content--dr2VP";
export const logos = "twoColumnSection-module--logos--1RWyE";
export const logo = "twoColumnSection-module--logo--UksiV";